import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';
import MailWithPip from './MailWithPip';

export default function SocialIconWithTooltip({ name, href, size, style }) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isPressed, setIsPressed] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isTouchDevice, setIsTouchDevice] = useState(false);

    const hideTimeoutRef = useRef(null);
    const wrapperRef = useRef(null);

    // Detectar pantallas táctiles
    useEffect(() => {
        setIsTouchDevice(
            "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0
        );
    }, []);

    // limpiar timeout de copia al desmontar
    useEffect(() => {
        return () => {
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        };
    }, []);

    const isMail =
        name?.toLowerCase().includes("mail") ||
        name?.toLowerCase().includes("gmail") ||
        name?.toLowerCase().includes("correo") ||
        name?.toLowerCase().includes("email");

    // ⭐ FIX DEFINITIVO PARA CENTRAR EL ICONO (incluyendo mail)
    const linkStyle = {
        ...style,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: isPressed
            ? "#e2e2e2ff"
            : (isHovered ? "rgba(0,0,0,0.5)" : "black"),
        filter: isPressed ? "grayscale(100%) brightness(85%)" : undefined,
        transition: "filter 120ms ease, color 120ms ease",
        outline: "none",
        WebkitTapHighlightColor: "transparent"
    };

    // Email sin "mailto:" (se pasa al componente MailWithPip también)
    const tooltipContent = isMail && typeof href === 'string' && href.toLowerCase().startsWith('mailto:')
        ? href.replace(/^mailto:/i, '')
        : href;

    const mailHref = isMail
        ? (typeof href === 'string' && href.toLowerCase().startsWith('mailto:') ? href : `mailto:${tooltipContent}`)
        : href;

    return (
        <div ref={wrapperRef} style={{ position: "relative", display: "inline-block" }}>
            {isMail ? (
                // Usar componente separado para el mail + piquito
                <MailWithPip name={name} href={mailHref} size={size} style={style} />
            ) : (
                <a
                    href={href}
                    onClick={() => {}}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseEnter={() => { if (!isTouchDevice) setIsHovered(true); }}
                    onMouseLeave={() => { if (!isTouchDevice) { setIsHovered(false); setIsPressed(false); } }}
                    onTouchStart={() => { setIsPressed(true); setIsHovered(false); }}
                    onTouchEnd={() => { setIsPressed(false); setIsHovered(false); }}
                    onTouchCancel={() => { setIsPressed(false); setIsHovered(false); }}
                    onFocus={() => !isTouchDevice && setIsHovered(true)}
                    onBlur={() => { setIsHovered(false); setIsPressed(false); }}
                    onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') setIsPressed(true); }}
                    onKeyUp={(e) => { if (e.key === ' ' || e.key === 'Enter') setIsPressed(false); }}
                    style={linkStyle}
                >
                    <Icon name={name} size={size} />
                </a>
            )}
        </div>
    );
}
